// User reducer types
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED'
export const SET_UNAUTHENTICATED = 'SET_UNAUTHENTICATED'
export const SET_USER = 'SET_USER'
export const LOADING_USER = 'LOADING_USER'
export const STOP_LOADING_USER = 'STOP_LOADING_USER'
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
export const EDIT_USER = 'EDIT_USER'
export const CHANGE_IMAGE = 'CHANGE_IMAGE'

// UI reducer types
export const SET_TITLE = 'SET_TITLE'
export const SET_ERRORS = 'SET_ERRORS'
export const CLEAR_ERRORS = 'CLEAR_ERRORS'
export const LOADING_UI = 'LOADING_UI'
export const STOP_LOADING_UI = 'STOP_LOADING_UI'

// Document reducer types
export const SET_PAGE = 'SET_PAGE'
export const INCREMENT_REFRESH = 'INCREMENT_REFRESH'
export const SET_DOCUMENT_FROM_REDUX = 'SET_DOCUMENT_FROM_REDUX'
export const SET_DOCUMENT_FROM_DB = 'SET_DOCUMENT_FROM_DB'
export const SET_LAST_VISIBLE_DOCUMENT = 'SET_LAST_VISIBLE_DOCUMENT'
export const SET_DOCUMENTS = 'SET_DOCUMENTS'
export const PAGINATE_DOCUMENTS = 'PAGINATE_DOCUMENTS'
export const CREATE_DOCUMENT = 'CREATE_DOCUMENT'
export const MODIFY_DOCUMENT = 'MODIFY_DOCUMENT'
export const REMOVE_DOCUMENT = 'REMOVE_DOCUMENT'
export const STORE_DOCUMENT = 'STORE_DOCUMENT'
export const UPDATE_PROFILE_IN_DOCUMENT = 'UPDATE_PROFILE_IN_DOCUMENT'
export const LOADING_DOCUMENT = 'LOADING_DOCUMENT'
export const STOP_LOADING_DOCUMENT = 'STOP_LOADING_DOCUMENT'
export const SET_DOCUMENT_NOT_FOUND = 'SET_DOCUMENT_NOT_FOUND'
export const RESET_DOCUMENT = 'RESET_DOCUMENT'

// Notification reducer types
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS'
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION'
export const LOADING_NOTIFICATION = 'LOADING_NOTIFICATION'
export const STOP_LOADING_NOTIFICATION = 'STOP_LOADING_NOTIFICATION'
export const RESET_NOTIFICATION = 'RESET_NOTIFICATION'

// Image reducer types
export const ADD_IMAGE = 'ADD_IMAGE'
export const CLEAR_IMAGES = 'CLEAR_IMAGES'
export const LOADING_IMAGE = 'LOADING_IMAGE'
export const STOP_LOADING_IMAGE = 'STOP_LOADING_IMAGE'

// Textbox reducer types
export const ADD_TEXTBOX = 'ADD_TEXTBOX'
export const CLEAR_TEXTBOXES = 'CLEAR_TEXTBOXES'
export const LOADING_TEXTBOX = 'LOADING_TEXTBOX'
export const STOP_LOADING_TEXTBOX = 'STOP_LOADING_TEXTBOX'

// Sketch reducer types
export const CREATE_SKETCH = 'CREATE_SKETCH'
export const DELETE_SKETCH = 'DELETE_SKETCH'
export const CLEAR_SKETCH = 'CLEAR_SKETCH'
export const OPEN_SKETCH_MODAL = 'OPEN_SKETCH_MODAL'
export const CLOSE_SKETCH_MODAL = 'CLOSE_SKETCH_MODAL'

//Profile reducer types
export const SET_PROFILE_FROM_REDUX = 'SET_PROFILE_FROM_REDUX'
export const SET_PROFILE_FROM_DB = 'SET_PROFILE_FROM_DB'
export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const SET_PROFILES = 'SET_PROFILES'
export const LOADING_PROFILE = 'LOADING_PROFILE'
export const SET_PROFILE_NOT_FOUND = 'SET_PROFILE_NOT_FOUND'
export const RESET_PROFILE = 'RESET_PROFILE'

//Overview reducer types
export const SET_OVERVIEW = 'SET_OVERVIEW'
export const UPDATE_OVERVIEW = 'UPDATE_OVERVIEW'
export const CHANGE_DROPDOWN_OPTION = 'CHANGE_DROPDOWN_OPTION'
export const LOADING_OVERVIEW = 'LOADING_OVERVIEW'
export const STOP_LOADING_OVERVIEW = 'STOP_LOADING_OVERVIEW'
export const RESET_OVERVIEW = 'RESET_OVERVIEW'
